import React from 'react';
import ToolsMenu from '@/components/tools/ToolsMenu';
import DataManagementDataModelTools from './DataManagementDataModelTools';

const DataManagementDataModelToolsMenu = ({
  disableValidate,
  listItem,
  name,
  upward,
  showReports,
  validate,
}) => (
  <ToolsMenu listItem={listItem} upward={upward}>
    <DataManagementDataModelTools
      disableValidate={disableValidate}
      name={name}
      showReports={showReports}
      validate={validate}
    />
  </ToolsMenu>
);

export default DataManagementDataModelToolsMenu;
